import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { ColumnSettings } from '../../common/models';
import { MultiSelectModule } from 'primeng/multiselect';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'multi-select-editor',
  templateUrl: './multi-select-editor.component.html',
  styleUrl: './multi-select-editor.component.scss',
  imports: [
    MultiSelectModule,
    FormsModule
  ]
})
export class MultiSelectEditorComponent implements OnChanges {
  @Input('record') record: any;
  @Input('column') column!: ColumnSettings;

  public options: any[] = [];
  public optionLabelName: string = '';
  public selectedOptions: any[] = [];

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['record'] || changes['column']) {
      if (!this.column.multiSelectSettings) {
        throw 'this.column.multiSelectSettings cannot be null';
      }

      this.optionLabelName = this.column.multiSelectSettings.textField;
      this.options = this.column.multiSelectSettings.data as any[];
      this.selectedOptions = this.options.filter(o => this.record[this.column.field].includes(o[this.column.multiSelectSettings!.valueField]))
        .map(o => o[this.column.multiSelectSettings!.valueField]);
    }
  }

  public onModelChange(change: any): void {
    this.record![this.column.field] = change;
  }
}
